import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;

export const Logotipo = styled.img`
  height: 5rem;
`;

export const FormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4rem 0;
  width: 100%;
  gap: 2rem;
  font-family: ${styleSheet.mainFont};
  font-size: 1.6rem;
  
  span {
    font-size: 1.3rem;
    font-family: ${styleSheet.mainFont};
  }
`;

export const InputLabel = styled.label`
  font-family: ${styleSheet.mainFont};
  font-size: 1.4rem !important;
  margin-bottom: 2rem;  
  font-weight: 600 !important;
  color: ${styleSheet.darkerGrey}!important;
`;

export const InfoCodeContainer = styled.span`
  width: 100%;
  font-size: 1.3rem;
  font-family: ${styleSheet.mainFont};
`;

export const CodeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const InfoButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`;

export const CodeText = styled.p`
  margin-top: 3rem;
  font-size: 1.8rem;
  color:  ${styleSheet.darkerGrey}
`;

export const ResendCodeText = styled.p`
  margin-top: 1rem;
  font-size: 1.4rem;
  color:  ${styleSheet.darkerGrey}
`;

export const ResendCodeLink = styled.span`
  text-decoration: none;
  fontWeight: bold;
  color:  #54278b;
  transform: 0.2s color ease-out;
  cursor: pointer;

  &:hover {
    color:  ${styleSheet.colorMainDark}
  }
`;
